module.exports = __webpack_public_path__ + "static/hero-heart-bb09f1bf99aa74320a836030026ae062.svg";